/* @flow */

import React from 'react';
import { Table, Segment, Message } from 'semantic-ui-react';
import ArchiveItem from './ArchiveItem';

type Props = {
  archives: List<CatalogPage>,
  onUnarchive: (page: CatalogPage) => void,
};

const ArchiveList = ({ archives, onUnarchive }: Props) => {
  if (archives && archives.size) {
    return (
      <Segment>
        <Table basic="very">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={8} textAlign="center">
                Nom
              </Table.HeaderCell>
              <Table.HeaderCell width={4} textAlign="center">
                Type
              </Table.HeaderCell>
              <Table.HeaderCell width={4} textAlign="center">
                Actions
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {archives.map(a => (
              <ArchiveItem key={a.id} archive={a} onUnarchive={onUnarchive} />
            ))}
          </Table.Body>
        </Table>
      </Segment>
    );
  }

  return <Message icon="info circle" header="Aucune page archivée" />;
};

export default ArchiveList;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Archives/components/ArchiveList.js